export default __webpack_public_path__ + "assets/default-icon.290e09e569a1cab8e61ba93b0d23863f.png";